/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * ============================================================================
 * NOTE:
 * The logic in this file is duplicated in server/utils/template.js for
 * consistency between frontend and backend templating logic. Any changes here
 * should be reflected (and tested) in both locations.
 * ============================================================================
 */

/**
 * @module enervee_utils.cms
 */
TemplateService.$inject = [
    '$log',
];
function TemplateService(
    $log,
) {
    var _pub = {};
    var _defaultTextContext = {
        br: '<br>'
    };
    var catchallRe = getVariableRegex('\\w+');

    /**
     * Takes text that includes variables in the format {variable} and replaces
     * them with the values from the context. This function does not support
     * nested variables.
     *
     * @example
     * // Context should be an object with simple string values.
     * render(
     *   "This is {place}! Did you think {place} would fall that easily?",
     *   {
     *     place: "Sparta"
     *   }
     * );
     * // Resolves to: "This is Sparta! Did you think Sparta would fall that
     * // easily?"
     *
     * @param {String} text
     * @param {Object} context A hash of variables to render in the text.
     * @returns {String}
     */
    _pub.render = function (text, context) {
        var original = text;
        context = angular.extend({}, _defaultTextContext, context || {});

        Object.keys(context).forEach(function(key) {
            var contextValue = context[key];
            var re = getVariableRegex(key);
            text = text.replace(re, contextValue);
        });

        var unrenderedVars = text.match(catchallRe);
        if (unrenderedVars) {
            $log.warn(
                "Removing the following unrendered variables from text: " +
                "'" + original + "'",
                unrenderedVars
            );
            text = text.replace(catchallRe, '');
        }

        return text;
    };

    /**
     * Helper function to get the regular expression for finding a specific
     * variable in a chunk of text.
     *
     * @param {String} key
     * @return {RegExp}
     */
    function getVariableRegex(key) {
        return new RegExp('\\{' + key + '\\}', 'g');
    }

    return _pub;
}

module.exports = TemplateService;
